import React, { createContext, useState, useEffect } from "react";

export const UsuariosContext = createContext();

export function UsuariosProvider({ children }) {
    const [usuarios, setUsuarios] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchUsuarios = async () => {
        try {
            const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3002';
            const token = localStorage.getItem('token');

            console.log('🔍 [USUARIOS] API_URL:', API_URL);
            console.log('🔑 [USUARIOS] Token:', token ? 'Existe' : 'Não encontrado');
            console.log('📡 [USUARIOS] Fazendo requisição para:', `${API_URL}/master/usuarios`);

            const response = await fetch(`${API_URL}/master/usuarios`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            console.log('📊 [USUARIOS] Status da resposta:', response.status);

            if (!response.ok) {
                const errorData = await response.text();
                console.error('❌ [USUARIOS] Erro na resposta:', errorData);
                throw new Error(`Erro ao buscar usuários: ${response.status}`);
            }

            const data = await response.json();
            console.log('✅ [USUARIOS] Dados recebidos:', data);
            console.log('📈 [USUARIOS] Total de usuários:', data.length);

            setUsuarios(data);
            setLoading(false);
        } catch (error) {
            console.error("❌ [USUARIOS] Erro ao buscar usuários:", error);
            console.error("Detalhes:", error.message);
            setLoading(false);
        }
    };

    useEffect(() => {
        // NÃO chamar fetchUsuarios aqui - será chamado manualmente pelas páginas master
        // fetchUsuarios();
    }, []);

    return (
        <UsuariosContext.Provider value={{ usuarios, loading, fetchUsuarios }}>
            {children}
        </UsuariosContext.Provider>
    );
}
